import router from './router/';
import store from './store';

import website from '@/config/website';
import {
	getToken
} from '@/utils/auth';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({
	showSpinner: true
});
const lockPage = '/lock'; //锁屏页

const allowList = ['/lock', '/login', '/403', '/500',]
const loginRoutePath = '/login'
router.beforeEach((to, from, next) => {
	const defaultRoutePath = website.fistPage.path
	const meta = to.meta || {};
	const isMenu = meta.menu === undefined ? to.query.menu : meta.menu;
	store.commit('SET_IS_MENU', isMenu === undefined);
	if (getToken()) {
		if (store.getters.isLock && to.path !== lockPage) {
			//如果系统激活锁屏，全部跳转到锁屏页
			next({
				path: lockPage
			});
		} else if (to.path === loginRoutePath) {
			//如果登录成功访问登录页跳转到主页
			next({
				path: defaultRoutePath
			});
		} else {
			if (store.getters.token.length === 0) {
				store.dispatch('FedLogOut').then(() => {
					next({
						path: '/login'
					});
				});
			} else {
				const meta = to.meta || {};
				const query = to.query || {};
				if (meta.target) {
					window.open(query.url.replace(/#/g, '&'));
					return;
				} else if (meta.isTab !== false) {
					store.commit('ADD_TAG', {
						name: query.name || to.name,
						path: to.path,
						fullPath: to.path,
						params: to.params,
						query: to.query,
						meta: meta,
					});
				}
				next()
			}
		}
	} else {

		console.log(meta)
		console.log(to)

		if (meta.isAuth === false) {
			next();
		} else {

			let query = to.query
			query.redirect = to.path
			next({
				path: loginRoutePath,
				query: query
			})
		}




	}
});

router.afterEach(to => {
	NProgress.done();
	let title = router.$avueRouter.generateTitle(to, {
		label: 'name'
	});
	router.$avueRouter.setTitle(title);
	store.commit('SET_IS_SEARCH', false);
});